module.exports = __webpack_public_path__ + "img/folder.c3ea2c74.svg";